import { FooterV2 } from "@components/V2/Footer";
import { ArrowRightIcon } from "@phosphor-icons/react";
import { Button, Typography } from "@kelp-dao/kernel-design-system";
import { IMAGES } from "@constants/images";
import { getUrlForLocalImage } from "utils";
import Image from "next/image";

const GEOBLOCK_IMAGES = {
  mobile: "/assets/geoblock/mobile.avif",
  tablet: "/assets/geoblock/tablet.avif",
  desktop: "/assets/geoblock/desktop.avif",
  desktopXl: "/assets/geoblock/desktop-xl.avif",
};

const GeoFenced = () => {
  return (
    <div className="flex flex-col">
      {/* Main Content Area - Full viewport height, no overflow */}
      <main className="h-[100dvh] min-h-[100vh] relative overflow-hidden">
        {/* Responsive Background Images - Fixed size, crops from sides */}
        <picture className="absolute inset-0 flex items-end justify-center">
          <source
            media="(min-width: 1536px)"
            srcSet={getUrlForLocalImage(GEOBLOCK_IMAGES.desktopXl)}
          />
          <source
            media="(min-width: 1024px)"
            srcSet={getUrlForLocalImage(GEOBLOCK_IMAGES.desktop)}
          />
          <source
            media="(min-width: 640px)"
            srcSet={getUrlForLocalImage(GEOBLOCK_IMAGES.tablet)}
          />
          <img
            src={getUrlForLocalImage(GEOBLOCK_IMAGES.mobile)}
            alt="Region locked background"
            className="min-w-full min-h-full w-auto h-auto max-w-none object-cover object-bottom"
          />
        </picture>

        {/* Content Overlay - Positioned above middle */}
        <div className="absolute inset-0 z-10 flex flex-col items-center pt-[16vh] sm:pt-[18vh] md:pt-[15vh] lg:pt-[20vh] px-4 sm:px-6">
          {/* KernelDAO Logo */}
          <div className="mb-4 sm:mb-5 md:mb-6">
            <Image
              src={IMAGES.LOGOS.KERNEL_DAO.src}
              alt="KernelDAO"
              width={140}
              height={32}
              className="w-[140px] h-auto sm:w-[160px] md:w-[180px]"
            />
          </div>

          {/* Heading */}
          <Typography
            type="heading"
            color="textPrimary"
            className="text-xl sm:text-2xl lg:text-3xl font-bold text-center mb-2 font-sans"
          >
            Not available in your region
          </Typography>

          {/* Subtitle */}
          <Typography
            type="body"
            color="textSecondary"
            className="text-sm sm:text-base md:text-lg text-center mb-4 sm:mb-6 md:mb-8 max-w-md"
          >
            This product isn&apos;t available in your region right now.
          </Typography>

          {/* Read Docs Button */}
          <Button
            variant="outline"
            onClick={() =>
              window.open(
                "https://kerneldao.gitbook.io/kernel/getting-started/gain",
                "_blank"
              )
            }
          >
            Read our docs
            <ArrowRightIcon weight="bold" className="w-4 h-4 sm:w-5 sm:h-5" />
          </Button>
        </div>
      </main>

      {/* Footer */}
      <FooterV2 />
    </div>
  );
};

export default GeoFenced;
